import React from 'react';

const NoPage = () => {
  return (
    <div>
      <p>There's nothing here!</p>
    </div>
  )
}
export default NoPage;